function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "b",
  x1: "17.571%",
  x2: "54.143%",
  y1: "2.695%",
  y2: "55.465%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#3E3A52"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1E1C26"
})), React.createElement("path", {
  id: "a",
  d: "M0 0h1920v572H0z"
}), React.createElement("linearGradient", {
  id: "c",
  x1: "58.997%",
  x2: "-2.839%",
  y1: "83.273%",
  y2: "69.184%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#3E3A52"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1E1C26"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("use", {
  fill: "url(#b)",
  xlinkHref: "#a"
}), React.createElement("path", {
  fill: "url(#c)",
  mask: "url(#d)",
  transform: "matrix(-1 0 0 1 938 0)",
  d: "M936 173L2 571h934z"
}));

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 572
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI1NzIiIHZpZXdCb3g9IjAgMCAxOTIwIDU3MiI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImhlYWRlci1ibHVlLWIiIHgxPSIxNy41NzElIiB4Mj0iNTQuMTQzJSIgeTE9IjIuNjk1JSIgeTI9IjU1LjQ2NSUiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjM0UzQTUyIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzFFMUMyNiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxyZWN0IGlkPSJoZWFkZXItYmx1ZS1hIiB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI1NzIiLz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iaGVhZGVyLWJsdWUtYyIgeDE9IjU4Ljk5NyUiIHgyPSItMi44MzklIiB5MT0iODMuMjczJSIgeTI9IjY5LjE4NCUiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjM0UzQTUyIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzFFMUMyNiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxtYXNrIGlkPSJoZWFkZXItYmx1ZS1kIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjaGVhZGVyLWJsdWUtYSIvPgogICAgPC9tYXNrPgogICAgPHVzZSBmaWxsPSJ1cmwoI2hlYWRlci1ibHVlLWIpIiB4bGluazpocmVmPSIjaGVhZGVyLWJsdWUtYSIvPgogICAgPHBvbHlnb24gZmlsbD0idXJsKCNoZWFkZXItYmx1ZS1jKSIgcG9pbnRzPSI5MzYgMTczIDIgNTcxIDkzNiA1NzEiIG1hc2s9InVybCgjaGVhZGVyLWJsdWUtZCkiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDkzOCAwKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgComponent as ReactComponent };